export const css = {
	root: 'IUInj-vj',
	secondary: '_3CX0345u',
	required: 'UvKrchjc',
	' _key': 'afcpe-theme/dojo/label'
};

export default css;
